import React, { useContext } from 'react';
import _get from 'lodash/get';

import { Loader } from 'components';
import { TableZeroState } from 'components/Tables';
import Error from './Error';
import { ReactTablesContext } from '../..';

export default function SearchState({
  noRecordIcon = null,
  noRecordsMessage = null,
  errorMessage = 'There was an error fetching the data',
  children = null
}) {
  const {
    refinements,
    searchState: { isFetchingData, isDataFetchingError, isEmpty }
  } = useContext(ReactTablesContext);

  const searchQuery = _get(refinements, 'search', '');

  if (!isFetchingData && isDataFetchingError) {
    return <Error message={errorMessage} />;
  } else if (!isFetchingData && isEmpty) {
    return (
      <TableZeroState searchQuery={searchQuery} icon={noRecordIcon}>
        {noRecordsMessage}
      </TableZeroState>
    );
  }

  return (
    <>
      <Loader loading={isFetchingData} className="table-loader" />
      {children}
    </>
  );
}
